import { useEffect, useState } from "react"



const sanMenuItem = (wpItem) => ({
    id: wpItem.ID,
    url: wpItem.url,
    title: wpItem.title,
    target: wpItem.target,
    isActive: wpItem.is_active,
    children: []
})

export const useWPMenuTree = (wpMenuData) => {
    const [menuTree, setMenuTree] = useState([])


    useEffect(() => {
        if(!wpMenuData.hasOwnProperty('order')) {
            return 
        }

        const { order, items } = wpMenuData
        const itemsArrayFirst = []
        const itemsArraySec = []

        order.forEach(id => {
            const item = items[id]

            if('0' === item.menu_item_parent) {
                itemsArrayFirst.push(item)
            } else {
                itemsArraySec.push(item)
            }
        })

        const tree = itemsArrayFirst.map(itemFirst => {
            const sanItemFirst = sanMenuItem(itemFirst)
            let ariaActiveFirst = sanItemFirst.isActive


            const children = itemsArraySec.filter(i => sanItemFirst.id == i.menu_item_parent).map((itemSec, indexSec) => {
                const sanItemSec = sanMenuItem(itemSec)

                if(ariaActiveFirst && sanItemSec.isActive) {
                    ariaActiveFirst = false
                }

                return ({
                    ...sanItemSec,
                    ariaActive: sanItemSec.isActive

                })
            })

            return {
                ...sanItemFirst,
                ariaActive: ariaActiveFirst,
                children: children
            }
        })

        // const tree = itemsArrayFirst.map((itemFirst, indexFirst) => {
        //     const sanItemFirst = sanMenuItem(itemFirst, indexFirst)
        //     const children = itemsArraySec.filter(i => sanItemFirst.id == i.menu_item_parent).map((itemSec, indexSec) => sanMenuItem(itemSec, indexSec))

        //     return {
        //         ...sanItemFirst,
        //         children: children
        //     }
        // })
        
        setMenuTree(tree)
    }, [])


    const changeMenuTree = (idFirstLevel = null, idSecLevel = null) => {
        const newTree = menuTree.map(firstItem => ({
            ...firstItem,
            isActive: firstItem.id === idFirstLevel,
            children: firstItem.children.map(secItem => ({
                ...secItem,
                isActive: secItem.id === idSecLevel

            }))
        }))


        setMenuTree(newTree)
    }

    return [menuTree, changeMenuTree]
}